import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { BookFinderApp } from "./BookFinderApp";
import { ContactsApp } from "./ContactsApp";
import { RecipeApp } from "./RecipeApp";
import { OpenDataPortal } from "./OpenDataPortal";
import { Vertex } from "./Vertex";
import Logo from "./assets/dps-logo-black.svg";

export default function App() {
  return (
    <Router>
      <Switch>
        <Route path="/ContactsApp">
          <ContactsApp logo={Logo} />
        </Route>
        <Route path="/RecipeApp">
          <RecipeApp logo={Logo} />
        </Route>
        <Route path="/BookFinderApp">
          <BookFinderApp logo={Logo} />
        </Route>
        <Route path="/OpenDataPortal">
          <OpenDataPortal logo={Logo} />
        </Route>
        <Route path="/VertexAI">
          <Vertex logo={Logo} />
        </Route>
      </Switch>
    </Router>
  );
}
